import {
  OZONETEL_SCRIPT_SELECTOR,
  OZONETEL_SDK_URL,
  type OzonetelWindow,
} from '../../consts/ozonetel/sdk';
import { getOzonetelSdk } from './getSdk';

export function loadOzonetelSdk() {
  const ozonetelWindow = window as OzonetelWindow;
  if (getOzonetelSdk()?.initialize) {
    return Promise.resolve();
  }
  if (ozonetelWindow.__UA_OZONETEL_SDK_LOADING__) {
    return ozonetelWindow.__UA_OZONETEL_SDK_LOADING__;
  }

  ozonetelWindow.__UA_OZONETEL_SDK_LOADING__ = new Promise<void>((resolve, reject) => {
    const handleError = () => {
      ozonetelWindow.__UA_OZONETEL_SDK_LOADING__ = undefined;
      reject(new Error('Failed to load Ozonetel SDK'));
    };
    const existingScript = document.querySelector<HTMLScriptElement>(OZONETEL_SCRIPT_SELECTOR);
    if (existingScript) {
      if (existingScript.dataset.uaOzonetelLoaded === 'true') {
        resolve();
        return;
      }
      existingScript.addEventListener('load', () => resolve(), { once: true });
      existingScript.addEventListener('error', handleError, { once: true });
      return;
    }

    const script = document.createElement('script');
    script.async = true;
    script.dataset.uaOzonetelSdk = 'true';
    script.src = OZONETEL_SDK_URL;
    script.onload = () => {
      script.dataset.uaOzonetelLoaded = 'true';
      resolve();
    };
    script.onerror = handleError;
    document.head.appendChild(script);
  });

  return ozonetelWindow.__UA_OZONETEL_SDK_LOADING__;
}
